import Card from 'react-bootstrap/Card';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Button } from 'react-bootstrap';

import dashboardImg_1 from 'Images/public/datasubmission/Dashboard_image_1.svg';
import dashboardImg_2 from 'Images/public/datasubmission/Dashboard_image_2.svg';
import dashboardImg_3 from 'Images/public/datasubmission/Dashboard_image_3.svg';

//import {ACTIONS,formInfoReducer} from 'Containers/Private/Organization/OrganizationFormDataReducer';
//import { useDispatch } from "react-redux";
import { useState, useRef  } from 'react';
//import { dateInputDataReducer, ACTIONS } from 'Components/Forms/FormReducers/DateInputReducer';
//import DynamicPopup from 'Components/Popup/DynamicPopup';
import { ICONS } from 'Utils/icons';
import checkIcon from 'Images/shieldcheck.png';
import datasetIcon from 'Images/Dataset.png';
import postIcon from 'Images/postplus.png';
import connectIcon from 'Images/connect.png';
import { IconTextButton, TextButton } from 'Components/Button';
import { NumberedStepsSplit } from 'Components/Public/NumberedSteps/NumberedSteps';
//import { FloatingCallToAction, FloatingCallToActionEmpty } from 'Components/Public/FloatingCallToAction/FloatingCallToAction';
//import UpcomingEvents from 'Containers/Private/Dashboard/UpcomingEvents/UpcomingEvents';

import maineLogo from 'Images/maine.png';
import atriumLogo from 'Images/atrium.png';
import tennLogo from 'Images/tenn.png';
import { isLoggedIn, openInNewTab } from 'Utils/utilityFunctions';
import { useNavigate } from 'react-router-dom';
import { PATHS } from 'Utils/PagePaths';

function Home () {
    const navigate = useNavigate();
    const [date, setDate] = useState('');
    const ref = useRef(null);
    const step1Description =
      <>
          <p>
              Thanks to the <a href={`https://pso.ahrq.gov/resources/act`} target={`_blank`} className={`external-link`}>Patient Safety and Quality Improvement Act of 2005</a>, PSOs can help healthcare providers advance patient safety in a legally protected environment. If you are an existing PSO and you are registered with PSOPPC, you can log in to update your PSO Profile form annually.
          </p>
      </>;

    const [isHosClicked, setIsHosClicked] = useState(false);

    const handleInputDateChange = (e) => {
        //console.log(e.target);
        isDateEmpty(e);
        var val = e.target.value;
        //console.log(val);
        if (val != null) {
            var split = val.split("-");
            if (split[0].length > 4) {
                setDate((val.substring(val.length - 7, val.length)).padStart(10, "0"));
            }
            else {
                setDate(val);
            }
        }
        else {
            setDate('');
        }
    }

    const isDateEmpty = (e) => {
        //console.log("empty");
        //console.log(e.target.validity.valid);

        var val = e.target.value;
        //console.log(val);

        if (e.target.validity.valid == true) {
            if (val != null && val.length > 0) {
                return false;
            }
            else {
                return true;
            }
        }
        else {
            return false;
        }
    }

    const applyDateSelectorFormat = (val) => {
        //console.log(val);

        if (val != null) {
            var split = val.split("-");
            if (split[0].length > 4) {
                return (val.substring(val.length - 7, val.length)).padStart(10, "0");
            }
            else {
                return val;
            }
        }
        else {
            return '';
        }
    }

    const getDateFormat = (value) => {
        if (value != null) {
            var split = value.split('/');
            //console.log(split);
            if (split.length == 3) {
                return split[2] + '-' + split[0] + '-' + split[1];
            }
            return value;
        }
        return "test";
    }

    const [showPopup, setShowPopup] = useState(false);
   	const handleCreatePopup = (e) => {
        setShowPopup(true);
    }
    const handleHidePopup = (e) => {
        setShowPopup(false);
    }
    var popupButtons = [
        {
            text: "Okay",
            action: null,
            style: "outline"
        },
        {
            text: "Cancel",
            action: handleHidePopup,
            style: "filled"
        }
    ]
    return (

        <>
            <div className="public-home-header p-0 m-0">
                <Col className="z-1 d-flex flex-column  ms-auto me-auto gap-2 pt-5 px-3" md={11} lg={10} xl={8}>
                    
                    <h1 id="mainContent" className="public-title text-center m-0 mb-4 " >
                        <span className="start-text m-0 mb-4">Welcome to the</span>
                        <br></br>
                        <span className="black displayXL">Privacy Protection Center for</span>
                        <br></br>
                        <span className="blue-title displayXL">Patient Safety Organizations</span>
                    </h1>
                    <p className="public-intro header4 m-0">
                        Created by the Agency for Healthcare Research and Quality (AHRQ), the PSOPPC equips patient safety organizations (PSOs) with the secure strategies and national standards they need to collect, protect, and use patient safety data to reduce harm and improve care quality.
                    </p>
                </Col>
                <div className="home-header ">
                    <Col lg={10} xl="8" className='z-1' >
                        <h2 className="">How can we help?</h2>
                        <Row className="blue-text public-cards p-3 col-gap-2  m-0 mt-3 m-md-3 gx-0 gy-3 g-lg-3 row d-flex align-items-stretch">
                            <Col className="" lg={6}>
                                <Card className="h-100">
                                    <Card.Body className="d-flex flex-column flex-md-row align-items-start">
                                        <img alt="Shield icon with checkmark" src={checkIcon} ></img>
                                        <div>
                                            <div className="text-start mb-2"><span className="public-card-header horizontal ">We Protect Data</span></div>
                                            <div className="public-card-content ">
                                                <p>We support PSOs in protecting patient safety data—both through secure systems and non-identification—so that national learning can take place openly and without fear.</p>
                                            </div>
                                        </div>
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col className="" lg={6}>
                                <Card className="h-100">
                                    <Card.Body  className="d-flex flex-column flex-md-row align-items-start">
                                        <img alt="Add document icon" src={postIcon} ></img>
                                        <div>
                                            <div className="text-start mb-2"><span className="public-card-header horizontal ">We Standardize Data</span></div>
                                            <div className="public-card-content ">
                                                <p>We educate PSOs and providers on a set of Common Formats to collect, analyze, and help you standardize data that results in meaningful patient safety insights.</p>
                                            </div>
                                        </div>

                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col className=""  lg={6}>
                                <Card className="h-100">
                                    <Card.Body className="d-flex flex-column flex-md-row align-items-start">
                                        <img alt="Dataset icon"  src={datasetIcon} ></img>
                                        <div>
                                            <div className="text-start mb-2"><span className="public-card-header horizontal ">We Analyze Data</span></div>
                                            <div className="public-card-content ">
                                                <p>By securely sharing your PSO's patient safety data you contribute to national learning that helps improve the quality of care.</p>
                                            </div>
                                        </div>

                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col className=""  lg={6}>
                                <Card className="h-100">
                                    <Card.Body className="d-flex flex-column flex-md-row align-items-start">
                                        <img alt="People communicating icon" src={connectIcon} ></img>
                                        <div>
                                            <div className="text-start mb-2"><span className="public-card-header horizontal ">We Build Community</span></div>
                                            <div className="public-card-content ">
                                                <p>We bring PSOs together to share lessons, build connections, and grow through shared learning—all grounded in the use of Common Formats.</p>
                                            </div>
                                        </div>

                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </Col>
                </div>
            </div>
            <Row lg={10} className="main-content m-0  mb-4 mt-4  pt-4 pb-4 d-flex justify-content-center">

                <Col >

                    <div className="steps align-items">
                        <div className="step-title split col-lg-auto d-block d-md-grid">
                            <h2 className="text-start">
                                How you can get started with PSOPPC
                            </h2>
                        </div>




                        <NumberedStepsSplit
                            className="col-lg-12"
                            number={'01'}
                            stepTitle="Become a PSO"
                            stepText={step1Description}
                            stepContent={
                                 <div className="d-flex flex-column gap-3 w-xxs-100 w-sm-fit-content">
                                    <TextButton variant="normal" content="Learn how to become a PSO" onClick={()=>navigate(PATHS.public['Become a PSO'])} className=""></TextButton>   
                                    {   
                                        isLoggedIn() == true
                                        ?   null
                                        :   <TextButton variant="outline" content="Update existing PSO Profile" onClick={()=>navigate(PATHS.public['Sign In'])} className=""></TextButton> 
                                    }
                                    
                                </div>
                            }
                        >

                        </NumberedStepsSplit>


                        <NumberedStepsSplit
                            className="col-lg-12"
                            number={'02'}
                            stepTitle="Use Common Formats"
                            stepText={"To analyze and learn from patient safety data, we've created a set of Common Formats for PSOs to use."}
                            stepContent={
                                <div className="d-flex flex-column gap-3 w-xxs-100 w-sm-fit-content">
                                    <TextButton variant="normal" content="Learn how to use Common Formats" onClick={()=>navigate(PATHS.public['Use Common Formats'])}></TextButton>
                                </div>
                            }
                        >

                            <Row className="public-cards justify-content-end m-0 p-0 col-lg-auto gy-1 gx-1">
                                <Row className="m-0 p-0">
                                    <Col lg={4} className=" g-1">
                                        <Card as={Button} className="h-100 blue-card p-0" onClick={()=> navigate(PATHS.public['Community Pharmacy'])}>
                                            <Card.Body className="d-flex flex-column row-gap-3 align-items-center">
                                                {ICONS.communitypharmacy()}
                                                <div>
                                                    <p className="public-card-header horizontal text-center">Community Pharmacy</p>
                                                    <div className="public-card-content ">
                                                        <p>Version 1.0</p>
                                                    </div>
                                                </div>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                    <Col lg={4} className="g-1">
                                        <Card as={Button} className="h-100 blue-card p-0" onClick={()=> navigate(PATHS.public['Diagnostic Safety'])}>
                                            <Card.Body className="d-flex flex-column row-gap-3 align-items-center">
                                                {ICONS.ds()}
                                                <div>
                                                    <p className="public-card-header horizontal text-center">Diagnostic Safety</p>
                                                    <div className="public-card-content ">
                                                        <p>Version 1.0</p>
                                                    </div>
                                                </div>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                    <Col lg={4} className="g-1 flip-card">
                                        <Card as={Button} className="h-100 blue-card p-0" onClick={()=> navigate(PATHS.public['Hospital Version 1.2'])/*setIsHosClicked(true)} onBlur={()=> setIsHosClicked(false)*/}>
                                            <Card.Body className="d-flex flex-column row-gap-3 align-items-center">
                                                {ICONS.hs()}
                                                <div>
                                                    <p className="public-card-header horizontal text-center">Hospital</p>
                                                    
                                                    <div className="public-card-content ">
                                                        <p>Version 1.2</p>
                                                        <p>Version 2.0</p>
                                                    </div>
                                                          
                                                </div>
                                            </Card.Body>
                                            
                                        </Card>
                                    </Col></Row>
                                <Row className="m-0 p-0 ">
                                    <Col lg={4} className="g-1">
                                        <Card as={Button} className="h-100 blue-card p-0" onClick={()=> navigate(PATHS.public['Nursing Home'])}>
                                            <Card.Body className="d-flex flex-column row-gap-3 align-items-center">
                                                {ICONS.nursinghome()}

                                                <div>
                                                    <p className="public-card-header horizontal text-center">Nursing Home</p>
                                                    <div className="public-card-content ">
                                                        <p>Version 1.0</p>
                                                    </div>
                                                </div>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                    <Col lg={4} className="g-1">
                                        <Card as={Button} className="h-100 blue-card p-0" onClick={()=> navigate(PATHS.public['Surveillance - Hospital'])}>
                                            <Card.Body className="d-flex flex-column row-gap-3 align-items-center">
                                                {ICONS.sh()}
                                                <div>
                                                    <p className="public-card-header horizontal text-center">Surveillance Hospital</p>
                                                    <div className="public-card-content ">
                                                        <p>Version 1.0</p>
                                                    </div>
                                                </div>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                </Row>
                            </Row>


                        </NumberedStepsSplit>

                        <NumberedStepsSplit
                            number={'03'}
                            stepTitle="Submit Data for National Learning"
                            stepText={"To create national  trends, we rely on PSOs to voluntarily submit patient safety data."}
                            stepContent={
                                <TextButton variant="normal" content="Learn how to submit data" className="w-xs-100 w-sm-fit-content justify-content-center" onClick={()=>navigate(PATHS.public['Submit Data'])}></TextButton>
                            }
                        >

                        </NumberedStepsSplit>
                        <NumberedStepsSplit
                            number={'04'}
                            stepTitle="See Your Data in Action"
                            stepText={"We add your voluntarily submitted data to the Network of Patient Safety Databases (NPSD) and analyze it alongside other PSOs' data to uncover trends, benchmarks, and ideas to improve the safety of healthcare."}
                            stepContent={
                                <TextButton variant="normal" content="Learn from the data" className="w-xs-100 w-sm-fit-content justify-content-center" onClick={()=>navigate(PATHS.public['Learn from the Data'])}></TextButton>
                            }
                        >
                            <Row className="public-cards m-0 scrollable pb-3 gap-3 row-gap-3 d-flex flex-column flex-lg-row flex-lg-nowrap">
                                <Col className="p-0">
                                    <Card className="h-100">
                                        <Card.Body>
                                            <p className="public-card-header">The NPSD Dashboards</p>
                                            <div className="public-card-content align-items-start mb-3">
                                            	{/* remove alt text="NPSD Dashboard" for the image, it cause redundant alternative text 508 alert */}
                                                <img alt="" className="mb-2 maxHeight--100 w-100" src={dashboardImg_1} ></img>
                                                <p>Almost three-fourths of incident blood events during 2024 involved red blood cells as the type of blood product.</p>
                                            </div>
                                            <div className="public-card-footer">
                                                <IconTextButton 
                                                    variant={'clear'} 
                                                    icon={ICONS.launch} 
                                                    className="reverse p-0" 
                                                    content={'View NPSD Dashboards'}
                                                    onClick={() =>
                                                        openInNewTab('https://www.ahrq.gov/npsd/data/dashboard/index.html')
                                                    }
                                                ></IconTextButton>
                                            
                                            </div>
                                        </Card.Body>
                                    </Card>
                                </Col>
                                <Col className="p-0">
                                    <Card className="h-100">
                                        <Card.Body>
                                            <p className="public-card-header">Hospital Version 1.2 Clinical Dashboards*</p>
                                            <div className="public-card-content align-items-start mb-3">
                                                <img alt="NPSD Chartbook" className="mb-2 maxHeight--120 w-100" src={dashboardImg_2}></img>
                                                <p>
                                                    Incidents of unknown harm dropped from 10.4% in 2020 to 3.2% in 2023.
                                                </p>
                                            </div>
                                            
                                            <div className="public-card-footer text-start">
                                                <p className={`public-card-footer-note`}>
                                                    *Clinical National Dashboards are available to submitting PSOs. The data above is sample data.
                                                </p>
                                            </div>
                                        </Card.Body>
                                    </Card>
                                </Col>
                                <Col className="p-0">
                                    <Card className="h-100">
                                        <Card.Body>
                                            <p className="public-card-header">The NPSD Chartbooks</p>
                                            <div className="public-card-content align-items-start mb-3">
                                                <img alt="PSOPPC Clinical Dashboard" className="mb-2 maxHeight--120 w-100" src={dashboardImg_3}></img>
                                                <p>In 2024, 77.1% of pressure injury events were reported to have pressure injury preventive intervention in place.</p>
                                            </div>
                                            <div className="public-card-footer">
                                                <IconTextButton 
                                                    variant={'clear'} 
                                                    icon={ICONS.launch} 
                                                    className="reverse p-0" 
                                                    content={'View NPSD Chartbooks'}
                                                    onClick={() =>
                                                        openInNewTab('https://www.ahrq.gov/npsd/data/chartbook/index.html')
                                                    }
                                                ></IconTextButton>
                                            </div>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            </Row>
                        </NumberedStepsSplit>

                    </div>
                </Col>
               
            </Row>
            <Row className="main-content m-0 wavy-bg pt-4   pt-4 pb-4 pt-md-5 mb-0 mt-5  d-flex justify-content-center">
                <Col md={10} lg={9} className='how-psos' >
                    <Row className="text-start row-gap-3 row-gap-md-5">
                        <Col md={4} className="title-cell pb-0 pt-5 pb-md-5 mt-4">
                            <h2 >How PSOs work with us</h2>
                        </Col>
                        <Col md={8} className="d-flex flex-column align-items-start justify-content-center">
                            <p className="sec-desc">PSOs engage with the PSOPPC for help starting, growing, and evolving their patient safety operations. Here are a few examples. </p>
                            <IconTextButton variant="normal" icon={ICONS.launch} content="See all AHRQ listed PSOs" onClick={()=> {openInNewTab('https://pso.ahrq.gov/pso/listed')}} className="reverse w-xs-100 w-sm-fit-content d-flex  justify-content-center"></IconTextButton>
                        </Col>
                        <Col md={4} className="d-flex flex-column justify-content-between pb-5 pt-5 pt-md-5 pb-md-5">
                            <div>
                                <div className="org-img-container">
                                    <img className="org-image" alt="Maine Primary Care Association Logo" src={maineLogo}></img>
                                </div>
                                <div className="mb-3"><span className="org-name mb-1">Maine Primary Care Association</span></div>
                            </div>
                                

                            <div>
                                <p className="org-desc mt-auto">Maine Groups Improve Care for Patients with Intellectual/Developmental Disabilities</p>
                                <IconTextButton variant="normal" icon={ICONS.launch} content="View Case Study" onClick={()=> {openInNewTab('https://www.ahrq.gov/news/newsroom/case-studies/202201.html')}} className="reverse w-xs-100 w-sm-fit-content d-flex justify-content-center"></IconTextButton> 
                            </div>
                        </Col>
                        <Col md={4} className="d-flex flex-column justify-content-between pb-5 pt-5 pt-md-5 pb-md-5">
                            <div>
                                <div className="org-img-container">
                                    <img className="org-image" alt="Carolinas Rehabilitation PSO Logo" src={atriumLogo}></img>
                                </div>
                                <div className="mb-3"><span className="org-name mb-1">Carolinas Rehabilitation PSO</span></div>
                            </div>
                            <div>
                                <p className="org-desc  mt-auto">Patient Safety Organization Drives Inpatient Rehabilitation Quality Improvement</p>
                                <IconTextButton variant="normal" icon={ICONS.launch} content="View Case Study" onClick={()=> {openInNewTab('https://www.ahrq.gov/news/newsroom/case-studies/201705.html')}} className="reverse w-xs-100 w-sm-fit-content d-flex justify-content-center"></IconTextButton> 
                            </div>
                            
                        </Col>
                        <Col md={'4'} className="d-flex flex-column justify-content-between pb-5 pt-5 pt-md-5 pb-md-5">
                            <div>
                                <div className="org-img-container">
                                    <img className="org-image" alt="Tennessee Center for Patient Safety Logo" src={tennLogo}></img>
                                </div>
                                <div className="mb-3"><span className="org-name mb-1">Tennessee Center for Patient Safety</span></div>
                            </div>
                            <div>
                                <p className="org-desc  mt-auto">Tennessee Hospital Association Uses AHRQ Tools To Boost Patient Safety, Saving $17 Million</p>
                                <IconTextButton variant="normal" icon={ICONS.launch} content="View Case Study" onClick={()=> {openInNewTab('https://www.ahrq.gov/news/newsroom/case-studies/201702.html')}} className="reverse w-xs-100 w-sm-fit-content d-flex justify-content-center"></IconTextButton> 
                            </div>
                            
                        </Col>
                    </Row>
                </Col>
            </Row>
            {/*
            <Row className="d-flex justify-content-center events-container mb-5">
                <Col md={8} lg={12} xl={10} className='justify-self-center' >
                    <div className="title mb-5">
                        <p>Join Us</p>
                        <h2>Upcoming Events</h2>

                    </div>

                    <UpcomingEvents></UpcomingEvents>
                </Col>
            </Row>
            */}
        </>


    );
}

export default Home;
